export const unitsRoutes = {
  units: id => "/buildings/".concat(id, "/units"),
  unitsExtended: id => "/properties/".concat(id, "/units"),
  search: id => "/properties/".concat(id, "/units/search"),
  unitById: unitId => "/units/".concat(unitId),
  unitAvailabilityById: unitId => "/units/".concat(unitId, "/availability")
};